export default __webpack_public_path__ + "static/media/form-contact-golden.419dcbfb.svg";